import { service } from "@ember/service";
import { Ability } from "ember-can";
import AlertTriggeredJournalEvent from "parog-web/models/alert-triggered-journal-event";
import GenericPrescriptionUploadedJournalEvent from "parog-web/models/generic-prescription-uploaded-journal-event";
import type MedicationPrescribedJournalEvent from "parog-web/models/medication-prescribed-journal-event";
import TlsPrescribedJournalEvent from "parog-web/models/tls-prescribed-journal-event";
import type TreatmentPrescriptionChangedJournalEvent from "parog-web/models/treatment-prescription-changed-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

/**
 * Classic Ember class is used there because ability overload in parog does not
 * otherwise. The bug is not completely identified though.
 *
 * Note that Ability properties must be computed properties.
 * https://github.com/minutebase/ember-can/issues/83
 */
export default class PrescriptionAbility extends Ability {
  @service declare session: SemeiaSessionService;

  creationRoles = ["doctor", "nurse_lead"];
  declare model:
    | GenericPrescriptionUploadedJournalEvent
    | MedicationPrescribedJournalEvent
    | TreatmentPrescriptionChangedJournalEvent
    | TlsPrescribedJournalEvent;

  get canBatchRenewTls(): boolean {
    return Boolean(this.canCreate || this.session.medic?.hasRole("nurse"));
  }

  get canCopy(): boolean {
    return (
      !this.session.patient &&
      !(this.model instanceof GenericPrescriptionUploadedJournalEvent)
    );
  }

  get canCreate(): boolean {
    const medic = this.session.medic;
    return (
      Boolean(medic?.hasRole(...this.creationRoles)) ||
      Boolean(
        this.model instanceof AlertTriggeredJournalEvent &&
          (this.model as AlertTriggeredJournalEvent).isTlsPrescriptionAlert &&
          medic?.hasRole("nurse")
      )
    );
  }

  get canRead(): boolean {
    if (
      this.session.patient &&
      this.model instanceof TlsPrescribedJournalEvent
    ) {
      return false;
    }

    return true;
  }

  get canRenew(): boolean {
    return this.canCreate;
  }
}
